// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"d7cd242f","502":"dec4c112","2012":"464209d3"}[chunkId] + ".chunk.css";
};